import { getEmployees, getRequiredManagerPendingEmployees, getRequiredApprovalGroupEmployees, searchEmployees } from "../api/employeeList";
import { TimesheetType } from "../interfaces/TimesheetInterface";

// Function to grab employees based on pay period ID, type of timesheet, and supervisor ID
const grabEmployees = async (payPeriodID: number, type: TimesheetType, supervisorID: number, userID: number | null): Promise<any> => {

    try {
        // Make the API request to get the list of employees
        const apiResults = await getEmployees(payPeriodID, type, supervisorID, userID);

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Failed to fetch employees.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Return the authData to be used elsewhere
        return authData;

    } catch (err) {
        // Log any errors encountered during the fetch of employees
        console.error("Error in grabEmployees", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

// Function to grab required manager pending employees
const grabRequiredManagerPendingEmployees = async (payPeriodID: number, managerEmployeeID: number, adminUserEmployeeID?: number): Promise<any> => {
    try {
        const apiResults = await getRequiredManagerPendingEmployees(payPeriodID, managerEmployeeID, adminUserEmployeeID);

        if (!apiResults) {
            throw new Error("Failed to fetch required manager pending employees.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in grabRequiredManagerPendingEmployees", err);
        throw err;
    }
};

// Function to grab required approval group employees
const grabRequiredApprovalGroupEmployees = async (payPeriodID: number, approvalGroupID: number, adminUserEmployeeID?: number): Promise<any> => {
    try {
        const apiResults = await getRequiredApprovalGroupEmployees(payPeriodID, approvalGroupID, adminUserEmployeeID);

        if (!apiResults) {
            throw new Error("Failed to fetch required approval group employees.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in grabRequiredApprovalGroupEmployees", err);
        throw err;
    }
};

// Function to grab employee search results
const grabEmployeeSearch = async (searchString: string, payPeriodID: number, adminUserEmployeeID?: number): Promise<any> => {
    try {
        const apiResults = await searchEmployees(searchString, payPeriodID, adminUserEmployeeID);

        if (!apiResults) {
            throw new Error("Failed to search employees.");
        }

        return apiResults;
    } catch (err) {
        console.error("Error in grabEmployeeSearch", err);
        throw err;
    }
};

// Export the grabEmployees function to be used in other parts of the application
export { grabEmployees, grabRequiredManagerPendingEmployees, grabRequiredApprovalGroupEmployees, grabEmployeeSearch };
